import { SortItem } from './member.dashboard.license.response';

export class GlobalMACWhitelistBasic {
    ID: number;
    DateTimeCreated: Date;
    MACAddress: string;

    public static FixDates(item: GlobalMACWhitelistBasic) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }

}

export class GlobalMACWhitelistBasicArray extends Array<GlobalMACWhitelistBasic> {
    public LastSort: SortItem;

    constructor(...items: GlobalMACWhitelistBasic[]) {
        super(...items);
        Object.setPrototypeOf(this, GlobalMACWhitelistBasicArray.prototype);
    }

    public static FixDates(item: GlobalMACWhitelistBasicArray) {
        item.forEach(x => GlobalMACWhitelistBasic.FixDates(x));
    }

}
